import { Modal } from "bootstrap"
import { getMessaging, getToken, isSupported } from "firebase/messaging"
import initializeFirebaseApp from "../shared/firebase-app"
import ReactNativeTokenController from "./react_native_token_base_controller"

export default class extends ReactNativeTokenController {
  connect() {
    isSupported().then(isBrowserSupported => {
      if (isBrowserSupported) {
        switch (Notification.permission) {
          case "default":
            this.modal = new Modal(this.element)
            this.modal.show()
            break
          case "granted":
            this.#upsertToken()
        }
      } else if (window.ReactNativeWebView) {
        this.requestReactNativeToken()
      }
    })
  }

  request() {
    this.modal.hide()
    Notification.requestPermission().then(permission => {
      if (permission === "granted") {
        this.#upsertToken()
      }
    })
  }

  #upsertToken() {
    const firebaseApp = initializeFirebaseApp()

    getToken(getMessaging(firebaseApp), {
      vapidKey: "BOc4_m7EAmOB-ifWLIm23wjTAwNpGfwmZuf5ZZe575w580EDm95zM1RUXGT8LKwcQsnR2or4wOWZP2jIaFPuWiQ"
    }).then(token => {
      this.setTokenAndSubmitForm(token)
    })
  }
}
